module.exports = __webpack_public_path__ + "img/img_contact1.6f4a0e82.png";